const ARTICLE_REGULAR_TYPE = 'regular';
const RU_LANGUAGE = 'RU';

function handleAnchorClick(event) {
  event.preventDefault();
  const id = event.target.getAttribute('href')?.replace('#', '');
  const target = document.getElementById(id);

  if (!target) {
    return;
  }

  target.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  history.pushState(null, null, `#${id}`);
}

const initArticleTableContent = articleElement => {
  // article doesn't have correct type
  if (window.Site.targeting.article_type !== ARTICLE_REGULAR_TYPE) {
    return;
  }

  const contentElement = articleElement.querySelector('.formatted-body__content--wrapper');

  // article doesn't have a content
  if (!contentElement) {
    return;
  }

  const headerElements = contentElement.querySelectorAll('h2.formatted-body__header2, h3.formatted-body__header3');

  // article doesn't have any header tag and should be more then one H2 tag
  if (
    headerElements.length <= 1 ||
    Array.from(headerElements).filter(headerElement => headerElement.tagName === 'H2').length < 2
  ) {
    return;
  }

  // article has incorrect order of headers
  if (headerElements[0].tagName === 'H3') {
    return;
  }

  const pageHeaderElement = document.querySelector('.js-header');
  const pageHeaderNavElement = document.querySelector('.js-header-nav-container');

  const fragmentElement = document.createDocumentFragment();
  const listElement = document.createElement('ul');

  listElement.classList.add('table-content__list');

  headerElements.forEach(headerElement => {
    const randomHash = (Math.random() + 1).toString(36).substring(7);

    headerElement.setAttribute('id', randomHash);

    const headerHeight = pageHeaderElement ? parseInt(window.getComputedStyle(pageHeaderElement).height, 10) : 0;
    const navHeight = pageHeaderNavElement ? parseInt(window.getComputedStyle(pageHeaderNavElement).height, 10) : 0;
    const marginTop = parseInt(window.getComputedStyle(headerElement).marginTop, 10);

    headerElement.style = `scroll-margin-top: ${headerHeight + navHeight + marginTop}px`;

    const liElement = document.createElement('li');
    const linkElement = document.createElement('a');

    linkElement.setAttribute('href', `#${randomHash}`);
    linkElement.classList.add('table-content__link');

    const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const useElement = document.createElementNS('http://www.w3.org/2000/svg', 'use');

    if (headerElement.tagName === 'H2') {
      svgElement.classList.add('table-content__icon');
      useElement.setAttribute('href', '#ARROW_RIGHT_20');
    } else if (headerElement.tagName === 'H3') {
      svgElement.classList.add('table-content__icon', 'table-content__icon--small');
      useElement.setAttribute('href', '#ARROW_RIGHT_15');
    }

    svgElement.appendChild(useElement);
    linkElement.appendChild(svgElement);
    linkElement.appendChild(document.createTextNode(headerElement.textContent));
    liElement.appendChild(linkElement);
    linkElement.onclick = handleAnchorClick;

    if (headerElement.tagName === 'H2') {
      listElement.appendChild(liElement);
    } else if (headerElement.tagName === 'H3') {
      let newListElement = listElement.lastChild.querySelector('ul');

      if (!newListElement) {
        newListElement = document.createElement('ul');
        newListElement.classList.add('table-content__list', 'table-content__list--small');
        listElement.lastChild.appendChild(newListElement);
      }

      newListElement.appendChild(liElement);
    }
  });

  const navElement = document.createElement('nav');
  const titleElement = document.createElement('p');

  navElement.classList.add('table-content');
  titleElement.classList.add('table-content__title');

  titleElement.innerText = window.Site.targeting.language === RU_LANGUAGE ? 'СОДЕРЖАНИЕ' : 'МАЗМҰНЫ';

  navElement.appendChild(titleElement);
  navElement.appendChild(listElement);

  fragmentElement.appendChild(navElement);

  const advPlaceholderElement = contentElement.querySelector('aside');
  const articleSummaryElement = contentElement.querySelector('.article-summary');
  const firstParagraph = contentElement.querySelector('.formatted-body__paragraph');

  window.requestAnimationFrame(() => {
    if (articleSummaryElement) {
      articleSummaryElement.after(fragmentElement);
    } else if (advPlaceholderElement) {
      advPlaceholderElement.after(fragmentElement);
    } else if (firstParagraph) {
      firstParagraph.after(fragmentElement);
    }
  });
};

export {initArticleTableContent};
